const API_BASE = '/api/v1/export';

export interface ExportSections {
  profile: boolean;
  medications: boolean;
  familyHistory: boolean;
  healthNotes: boolean;
  measurements: boolean;
  wearable: boolean;
  labParameters: boolean;
}

export interface ExportOptions {
  startDate: string;
  endDate: string;
  filename?: string;
  sections: ExportSections;
}

export async function exportPDF(options: ExportOptions): Promise<Blob> {
  const response = await fetch(`${API_BASE}/pdf`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(options),
  });

  if (!response.ok) {
    throw new Error('Errore nella generazione del PDF');
  }

  return response.blob();
}

export async function exportCSV(options: ExportOptions): Promise<Blob> {
  const response = await fetch(`${API_BASE}/csv`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    credentials: 'include',
    body: JSON.stringify(options),
  });

  if (!response.ok) {
    throw new Error('Errore nella generazione del CSV');
  }

  return response.blob();
}

export function downloadBlob(blob: Blob, filename: string) {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
